import { Script } from 'gatsby';
import React, { type FC } from 'react';

export const CookieConsentScript: FC = () => {
    if (process.env['NODE_ENV'] === 'development') {
        return;
    }

    return <Script strategy="idle" src="/assets/js/cookie-consent.js?v=2025-12-19" />;
};
